import { t } from 'i18next'
import React, { useState } from 'react'
import { Modal, Alert } from 'react-bootstrap'
import { ButtonWithLoadingState } from '../Buttons/index.jsx'
import { getErrorMessageFromApiResponse } from '../../utils/api/apiUtils.js'
import PositionInstancesList from './LocalInstances/PositionInstancesList.jsx'
import useStores from '../../stores/useStore.js'
import useMountEffect from '../../utils/hooks/useMountEffect.js'
import { scrollToDataId } from '../../utils/utils.js'

const UpdateLocalInstances = () => {
  const { productsStore } = useStores()
  const [success, setSuccess] = useState('')
  const [error, setError] = useState('')
  const [isSaving, setIsSaving] = useState(false)
  useMountEffect(() => {
    scrollToDataId(
      `position-${productsStore.localInstanceObj.shoppingBasketArticleId}_${productsStore.localInstanceObj.positionId}`
    )
  })
  const handleClose = () => {
    productsStore.setShowUpdateLocalInstancesModal(false)
  }

  const handleSave = async () => {
    setIsSaving(true)
    setError('')
    try {
      await productsStore.saveAllPositionInstances()
      setSuccess(t('EmployeeFormSidebar:dataSaved'))
      productsStore.setShowUpdateLocalInstancesModal(false)
    } catch (e) {
      setError(getErrorMessageFromApiResponse(e))
    }
    setIsSaving(false)
  }
  return (
    <Modal size='xl' centered show={true} onHide={handleClose} scrollable>
      <Modal.Header closeButton className='pb-0'>
        <Modal.Title>
          <div>
            <p className='m-0 pt-2'>{t('Instances')}</p>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <PositionInstancesList />
        </div>
        {error ? <Alert variant='danger'>{error}</Alert> : null}
        {success ? <Alert variant='success'>{success}</Alert> : null}
      </Modal.Body>
      <Modal.Footer>
        <ButtonWithLoadingState
          variant='primary'
          buttonText={`${t('saveButton')}`}
          loadingText={t('createLocalInventory:saveLocalInventory')}
          isLoading={isSaving}
          onClick={handleSave}
        />
      </Modal.Footer>
    </Modal>
  )
}

export default UpdateLocalInstances
